
export default {
  name: 'summary-print-header',
  props: {
    morticianEmail: {},
    morticianName: {},
    morticianPhoneNumber: {}
  }
};
